(function(){
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const FT=window.FT||{},ROOT=FT.root||"/";
const SIZES=["S","M","L","XL","XXL"];
const A=n=>(FT.assets||"")+n;   /* theme asset url */
/* Store products come from Shopify. Until the store has products, a preview catalogue (ft-demo.js) is shown. */
const LIVE=(FT.products||[]).filter(p=>p.views&&p.views.length);
const DEMO=!LIVE.length;
const demoImg=s=>{const f=s.replace(/^img\//,"").replace("/","_").replace(/\.jpg$/,".webp");return{full:A(f),thumb:A("t_"+f)}};
const PRODUCTS=DEMO?(window.FT_DEMO||[]).map(p=>({...p,price:38,url:null,sizes:SIZES.map(l=>({label:l,id:null,available:true})),views:p.views.map(v=>{const i=demoImg(v.src);return{...v,src:i.full,thumb:i.thumb}})})):LIVE;
if(FT.product&&FT.product.views&&FT.product.views.length&&!PRODUCTS.some(p=>p.id===FT.product.id))PRODUCTS.push(FT.product);
const byId=Object.fromEntries(PRODUCTS.map(p=>[p.id,p]));
const money=n=>{n=+n||0;const s=n%1?n.toFixed(2):String(n);return(FT.money||"${{amount}}").replace(/\{\{\s*amount[a-z_]*\s*\}\}/,s)};
const PRICE0=PRODUCTS.length?PRODUCTS[0].price:38;
const COLORS={pink:"#ff3d8e",orange:"#ff6a1a",blue:"#2d55ff",yellow:"#ffd60a",mint:"#22d39c",violet:"#8b4dff",white:"#fbfbf7"};

/* ---------- toast ---------- */
let toT;function toast(m,ms=2600){const t=$("#toast");t.textContent=m;t.classList.add("show");clearTimeout(toT);toT=setTimeout(()=>t.classList.remove("show"),ms)}

/* ---------- theme ---------- */
const lights=$("#lights");
const isDark=()=>{const t=document.documentElement.dataset.theme;return t?t==="dark":matchMedia("(prefers-color-scheme: dark)").matches};
const syncLights=()=>{lights.setAttribute("aria-checked",String(!isDark()))};
lights.addEventListener("click",()=>{const t=isDark()?"light":"dark";document.documentElement.dataset.theme=t;try{localStorage.setItem("ft-theme",t)}catch(e){}syncLights()});
syncLights();

/* ---------- announcement ---------- */
const annEl=$("#announce");
if(annEl){const PAIRS0=[["pink","white"],["yellow","white"],["blue","white"],["mint","blue"],["violet","pink"]];
  let msgs=[];try{msgs=JSON.parse(annEl.dataset.ann||"[]").filter(Boolean)}catch(e){}
  if(!msgs.length)msgs=["Now dispensing: The Unprescribed Series","{count} tees · "+money(PRICE0)+" each","Free delivery. Obviously.","Returns within 30 days. No small talk.","Take one pill. See what happens."];
  const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  const annHTML=msgs.map((t,i)=>{const[a,b]=PAIRS0[i%PAIRS0.length];return`<span><i style="--c1:${COLORS[a]};--c2:${COLORS[b]}"></i>${esc(t.replace("{count}",PRODUCTS.length))}</span>`}).join("");
  annEl.innerHTML=annHTML+annHTML}

/* ---------- product card ---------- */
const THUMB=v=>v.thumb||v.src;
const FULL=v=>v.src;
const esc=s=>String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const CAN_HOVER=matchMedia("(hover:hover) and (pointer:fine)").matches;
let lastScroll=0;
addEventListener("scroll",()=>{lastScroll=Date.now()},{passive:true,capture:true});
function card(p,eager){
  const el=document.createElement("article");el.className="card";el.dataset.color=p.color;
  const a=p.views[0],b=p.views[1];
  el.innerHTML=`<div class="frame"><button class="shot" type="button" aria-label="${esc(p.name)} ${esc(p.code)}, ${money(p.price)}. Open details.">
      <img src="${THUMB(a)}" alt="" class="${a.cover?"cover":""} ${b&&CAN_HOVER?"base":""}" loading="${eager?"eager":"lazy"}" decoding="async" ${eager?'fetchpriority="high"':""} width="640" height="800">
      ${b&&CAN_HOVER?`<img data-src="${THUMB(b)}" alt="" class="alt ${b.cover?"cover":""}" decoding="async" width="640" height="800">`:""}
      <span class="rx">Rx ${p.rx}</span>
    </button>
    <div class="qa" aria-label="Quick add"><span class="lab">Quick add</span>${(p.sizes||[]).filter(s=>s.available!==false).map(s=>`<button type="button" data-s="${esc(s.label)}">${esc(s.label)}</button>`).join("")}</div></div>
    <div class="meta"><div class="nm">${esc(p.name)}<small>${esc(p.code)}</small></div><div class="pr">${money(p.price)}</div></div>`;
  const shot=el.querySelector(".shot");
  shot.querySelectorAll("img").forEach(im=>{const on=()=>im.classList.add("ld");im.complete&&im.naturalWidth?on():im.addEventListener("load",on,{once:true})});
  if(CAN_HOVER){const alt=shot.querySelector("img.alt");if(alt)el.addEventListener("pointerenter",()=>{if(!alt.src)alt.src=alt.dataset.src},{once:true})}
  let sx=0,sy=0,moved=false;
  shot.addEventListener("pointerdown",e=>{sx=e.clientX;sy=e.clientY;moved=false});
  shot.addEventListener("pointermove",e=>{if(Math.abs(e.clientX-sx)>8||Math.abs(e.clientY-sy)>8)moved=true});
  shot.addEventListener("click",e=>{if(moved||Date.now()-lastScroll<250){e.preventDefault();return}openProduct(p.id)});
  el.querySelectorAll(".qa button").forEach(x=>x.addEventListener("click",e=>{e.stopPropagation();addToCart(p.id,x.dataset.s)}));
  return el;
}

/* ---------- home: rail + tiles ---------- */
const DEMO_FEATURED=["thorazine-eye","oblivon","noritren","serenol","valium-mind","ritalin","visine","osporot"];
let FEATURED=(DEMO?DEMO_FEATURED:(window.FT_FEATURED||[])).filter(id=>byId[id]);
if(!FEATURED.length)FEATURED=PRODUCTS.slice(0,8).map(p=>p.id);
const rail=$("#rail");
if(rail){FEATURED.forEach((id,i)=>rail.appendChild(card(byId[id],i<3)));

const railCount=()=>{const c=rail.firstElementChild;if(!c)return;const step=c.getBoundingClientRect().width+18;const i=Math.min(FEATURED.length,Math.round(rail.scrollLeft/step)+1);$("#railCount").textContent=`${i} / ${FEATURED.length}`};
rail.addEventListener("scroll",railCount,{passive:true});
$("#prev").addEventListener("click",()=>rail.scrollBy({left:-(rail.firstElementChild.getBoundingClientRect().width+18),behavior:"smooth"}));
$("#next").addEventListener("click",()=>rail.scrollBy({left:rail.firstElementChild.getBoundingClientRect().width+18,behavior:"smooth"}));
railCount();}
const cnt=c=>PRODUCTS.filter(p=>p.color===c).length;
const setTxt=(s,t)=>{const e=$(s);if(e)e.textContent=t};
setTxt("#allCount",`(${PRODUCTS.length})`);setTxt("#cWhite",cnt("White")+" tees");setTxt("#cEcru",cnt("Ecru")+" tees");setTxt("#cBlack",cnt("Black")+" tees");

/* ---------- shop ---------- */
const grid=$("#grid");
if(grid){grid.innerHTML="";PRODUCTS.forEach(p=>grid.appendChild(card(p)));setTxt("#shopCount",PRODUCTS.length)}
const FX=[[0,8,-22,-6,-30,18,"pink","white",38],[-2,62,-26,4,10,-25,"blue","yellow",30],[30,-2,-4,-22,40,70,"mint","blue",34],[102,22,24,-8,-20,25,"orange","yellow",36],[100,78,22,10,60,110,"violet","pink",32],[97,95,20,6,-10,30,"yellow","white",28],[1,93,-20,8,20,-40,"pink","orange",24,1],[88,0,14,-20,0,0,"mint","mint",26,1],[-3,36,-22,0,0,0,"blue","blue",20,1]];
const TAGS=["Take 1 daily","Now dispensing","Refill ready","May cause joy","Side effect: style","Do not operate small talk","Shake well","Dose approved"];
document.querySelectorAll("#rail .card, #grid .card").forEach((c,ci)=>{
  const fx=document.createElement("div");fx.className="fx";fx.setAttribute("aria-hidden","true");
  fx.innerHTML='<div class="ring"></div>'+FX.map(([x,y,dx,dy,r0,r1,c1,c2,w,tab],i)=>`<span class="p${tab?" tab":""}" style="--x:${x}%;--y:${y}%;--dx:${dx}px;--dy:${dy}px;--r0:${r0}deg;--r1:${r1}deg;--c1:var(--${c1});--c2:${c2==="white"?"#fbfbf7":"var(--"+c2+")"};--w:${w}px;--d:${(i*.045).toFixed(2)}s"></span>`).join("")+`<span class="tag">${TAGS[ci%TAGS.length]}</span>`;
  c.querySelector(".frame").appendChild(fx);
});
function setFilter(f){
  $$(".cats .chip").forEach(x=>x.setAttribute("aria-pressed",String(x.dataset.f===f)));
  if(grid)grid.querySelectorAll(".card").forEach(k=>{k.hidden=!(f==="all"||k.dataset.color===f)});
}
$$(".cats .chip").forEach(c=>{const f=c.dataset.f;c.querySelector(".n").textContent=f==="all"?PRODUCTS.length:cnt(f);c.addEventListener("click",()=>setFilter(f))});

/* ---------- shop filter from the link (?f=white) ---------- */
{const f0=new URLSearchParams(location.search).get("f");const F={white:"White",ecru:"Ecru",black:"Black"}[(f0||"").toLowerCase()];if(F&&grid)setFilter(F)}

/* ---------- product dialog ---------- */
const dlg=$("#pd")||document.createElement("div");const IS_DLG=dlg.tagName==="DIALOG";let cur=null,curView=0,curSize=null;
function syncThumbs(i){$("#pdThumbs").querySelectorAll("button").forEach((b,j)=>b.setAttribute("aria-pressed",String(j===i)));$("#pdDots").querySelectorAll("i").forEach((d,j)=>d.classList.toggle("on",j===i))}
function setView(i,instant){if(window.resetZoom)resetZoom();curView=i;const tr=$("#pdTrack");tr.scrollTo({left:i*tr.clientWidth,behavior:instant?"instant":"smooth"});syncThumbs(i)}
let trT=0;
if($("#pdTrack"))$("#pdTrack").addEventListener("scroll",()=>{clearTimeout(trT);trT=setTimeout(()=>{const tr=$("#pdTrack");if(!tr.clientWidth||!cur)return;const i=Math.max(0,Math.min(cur.views.length-1,Math.round(tr.scrollLeft/tr.clientWidth)));if(i!==curView){curView=i;syncThumbs(i)}},60)},{passive:true});
function openProduct(id){
  cur=byId[id];if(!cur)return;curSize=null;
  $("#pdRx").textContent=`Rx ${cur.rx} · ${cur.color==="Black"?"After Hours":cur.color}`;
  $("#pdName").innerHTML=`${esc(cur.name)}<small>${esc(cur.code)}</small>`;
  if($("#pdPrice"))$("#pdPrice").textContent=money(cur.price);
  const lk=$("#pdLink");if(lk){lk.hidden=!cur.url;if(cur.url)lk.href=cur.url}
  $("#pdDesc").textContent=cur.desc;
  const th=$("#pdThumbs");th.innerHTML="";
  const tr=$("#pdTrack");tr.innerHTML="";$("#pdDots").innerHTML=cur.views.map(()=>"<i></i>").join("");
  cur.views.forEach((v,i)=>{const b=document.createElement("button");b.type="button";b.setAttribute("aria-label",v.label);b.innerHTML=`<img src="${THUMB(v)}" alt="" decoding="async">`;b.addEventListener("click",()=>setView(i));th.appendChild(b);
    const sl=document.createElement("div");sl.className="pd-slide";const im=document.createElement("img");im.className="pd-main"+(v.cover?" cover":"");im.alt=`${cur.name}, ${v.label}`;im.src=THUMB(v);im.decoding="async";im.draggable=false;sl.appendChild(im);tr.appendChild(sl);
    const f=new Image();f.onload=()=>{if(im.isConnected)im.src=f.src};f.src=FULL(v)});
  const sz=$("#pdSizes");sz.innerHTML="";
  (cur.sizes||[]).forEach(o=>{const s=o.label;const b=document.createElement("button");b.type="button";b.textContent=s;b.setAttribute("aria-pressed","false");if(o.available===false){b.disabled=true;b.title="Sold out";b.style.opacity=".35"}b.addEventListener("click",()=>{curSize=s;sz.querySelectorAll("button").forEach(x=>x.setAttribute("aria-pressed",String(x===b)));$("#pdHint").textContent=""});sz.appendChild(b)});
  $("#pdHint").textContent="";
  $("#pdFacts").innerHTML=[["Effect",esc(cur.micro)],["Fabric","Soft, structured cotton with a familiar sense of emptiness."],["Care","Machine wash cold, dry slowly, pretend you’re okay."],["Warning","Emotional stability not included."]].filter(Boolean).map(([k,v])=>`<div><dt>${k}</dt><dd>${v}</dd></div>`).join("");
  if(IS_DLG){if(!dlg.open)dlg.showModal();dlg.scrollTop=0;const sc=dlg.querySelector(".pd");if(sc)sc.scrollTop=0}
  setView(0,true);
}
if($("#pdClose"))$("#pdClose").addEventListener("click",()=>dlg.close());
if(IS_DLG)dlg.addEventListener("click",e=>{if(e.target===dlg)dlg.close()});
if($("#pdAdd"))$("#pdAdd").addEventListener("click",async()=>{if(!curSize){$("#pdHint").textContent="Select a size. We can’t guess. We tried.";return}const ok=await addToCart(cur.id,curSize);if(ok&&IS_DLG)dlg.close()});

/* ---------- zoom in place (inside the product photo frame) ---------- */
(function(){
  const tr=$("#pdTrack"),btn=$("#pdZoom");if(!tr)return;
  let s=1,tx=0,ty=0,img=null;const ptrs=new Map();let pinch=null,pan=null,moved=false,downAt=null;
  const curImg=()=>tr.children[curView]?.querySelector("img")||null;
  const apply=ease=>{if(!img)return;img.classList.toggle("ease",!!ease);img.style.transform=s>1?`translate(${tx}px,${ty}px) scale(${s})`:"";tr.classList.toggle("zoomed",s>1);if(btn)btn.setAttribute("aria-pressed",String(s>1))};
  const clamp=()=>{const r=img.parentElement.getBoundingClientRect();const mx=(s-1)*r.width/2,my=(s-1)*r.height/2;tx=Math.max(-mx,Math.min(mx,tx));ty=Math.max(-my,Math.min(my,ty))};
  const zoomAt=(ns,cx,cy,ease)=>{img=img||curImg();if(!img)return;const r=img.parentElement.getBoundingClientRect();const px=cx-(r.left+r.width/2),py=cy-(r.top+r.height/2);
    ns=Math.max(1,Math.min(4,ns));tx=px-(px-tx)*ns/s;ty=py-(py-ty)*ns/s;s=ns;if(s<=1.01){s=1;tx=ty=0}clamp();apply(ease)};
  window.resetZoom=ease=>{if(img){s=1;tx=ty=0;apply(ease)}s=1;tx=ty=0;img=null;tr.classList.remove("zoomed");if(btn)btn.setAttribute("aria-pressed","false")};
  tr.addEventListener("pointerdown",e=>{ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});moved=false;downAt={x:e.clientX,y:e.clientY};
    if(ptrs.size===2){const [a,b]=[...ptrs.values()];pinch={d:Math.hypot(a.x-b.x,a.y-b.y)};moved=true;img=img||curImg()}
    else if(s>1&&e.pointerType!=="mouse"){pan={x:e.clientX,y:e.clientY,tx,ty}}});
  tr.addEventListener("pointermove",e=>{if(downAt&&Math.hypot(e.clientX-downAt.x,e.clientY-downAt.y)>8)moved=true;
    if(ptrs.has(e.pointerId))ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(pinch&&ptrs.size===2){const [a,b]=[...ptrs.values()];const d=Math.hypot(a.x-b.x,a.y-b.y);zoomAt(s*d/pinch.d,(a.x+b.x)/2,(a.y+b.y)/2);pinch.d=d;return}
    if(pan&&s>1){tx=pan.tx+(e.clientX-pan.x);ty=pan.ty+(e.clientY-pan.y);clamp();apply()}
    else if(s>1&&e.pointerType==="mouse"){const r=img.parentElement.getBoundingClientRect();tx=-((e.clientX-r.left)/r.width-.5)*(s-1)*r.width;ty=-((e.clientY-r.top)/r.height-.5)*(s-1)*r.height;clamp();apply()}});
  const up=e=>{ptrs.delete(e.pointerId);if(ptrs.size<2)pinch=null;if(!ptrs.size){pan=null;downAt=null}};
  tr.addEventListener("pointerup",up);tr.addEventListener("pointercancel",up);
  tr.addEventListener("pointerleave",e=>{if(e.pointerType==="mouse"&&s>1)resetZoom(true)});
  tr.addEventListener("wheel",e=>{if(!e.ctrlKey)return;e.preventDefault();zoomAt(s*Math.exp(-e.deltaY*.01),e.clientX,e.clientY)},{passive:false});
  tr.addEventListener("click",e=>{if(moved){moved=false;return}if(s>1)resetZoom(true);else{img=curImg();zoomAt(2.5,e.clientX,e.clientY,true)}});
  if(btn)btn.addEventListener("click",e=>{e.stopPropagation();if(s>1)resetZoom(true);else{img=curImg();if(!img)return;const r=img.parentElement.getBoundingClientRect();zoomAt(2.5,r.left+r.width/2,r.top+r.height/2,true)}});
  /* a swipe to another photo or closing the sheet resets the zoom */
  tr.addEventListener("scroll",()=>{if(s>1&&img&&img!==curImg())resetZoom()},{passive:true});
  dlg.addEventListener("close",()=>resetZoom());
})();

/* ---------- cart (Shopify cart API) ---------- */
let cartState={item_count:0,items:[],total_price:0,total_discount:0};
const jfetch=(u,o)=>fetch(ROOT+u,{credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json"},...o});
async function refreshCart(){try{const r=await jfetch("cart.js");if(r.ok){cartState=await r.json();renderCart()}}catch(e){}}
async function addToCart(id,size){
  const p=byId[id];if(!p)return false;const s=(p.sizes||[]).find(x=>x.label===size);
  if(DEMO||!s||!s.id){toast("Preview shirt. Add your products in Shopify to sell it.",3200);return false}
  if(s.available===false){toast(`${size} is sold out.`);return false}
  try{const r=await jfetch("cart/add.js",{method:"POST",body:JSON.stringify({items:[{id:s.id,quantity:1}]})});
    if(!r.ok){const er=await r.json().catch(()=>({}));toast(er.description||"Couldn’t add that. Try again.");return false}}
  catch(e){toast("Couldn’t reach the store. Try again.");return false}
  await refreshCart();toast(`${p.name} · ${size} added to your Rx`);
  const ob=$("#openCart");if(ob&&ob.animate)ob.animate([{transform:"rotate(0)"},{transform:"rotate(-14deg) scale(1.15)"},{transform:"rotate(0)"}],{duration:450});
  return true;
}
async function changeLine(key,qty){try{const r=await jfetch("cart/change.js",{method:"POST",body:JSON.stringify({id:key,quantity:qty})});if(r.ok){cartState=await r.json();renderCart()}}catch(e){}}
function renderCart(){
  const n=cartState.item_count||0;setTxt("#cartCount",n);
  const box=$("#items");if(!box)return;
  setTxt("#sub",money((cartState.total_price||0)/100));
  const dr=$("#discRow");if(dr){const d=(cartState.total_discount||0)/100;dr.hidden=!d;setTxt("#disc","−"+money(d))}
  const co=$("#checkout");
  if(!n){box.innerHTML=`<p class="empty">Nothing prescribed yet. That’s fine too.</p>`;if(co)co.disabled=true;return}
  if(co)co.disabled=false;box.innerHTML="";
  cartState.items.forEach(it=>{
    const d=document.createElement("div");d.className="item";
    const img=it.image?it.image+(it.image.includes("?")?"&":"?")+"width=200":"";
    const opts=(it.options_with_values||[]).filter(o=>o.value&&o.value!=="Default Title").map(o=>o.value);
    d.innerHTML=`${img?`<img src="${esc(img)}" alt="">`:"<span></span>"}<div><div class="nm">${esc(it.product_title)}</div><div class="mono">${esc([...opts,"Qty "+it.quantity].join(" · "))}</div></div><div style="text-align:right"><div class="mono" style="font-size:13px;color:var(--ink)">${money(it.final_line_price/100)}</div><button type="button">Remove</button></div>`;
    d.querySelector("button").addEventListener("click",()=>changeLine(it.key,0));box.appendChild(d)});
}
const drawer=$("#drawer");
const openCart=e=>{if(e)e.preventDefault();if(!drawer)return;drawer.classList.add("open");drawer.setAttribute("aria-hidden","false");setTxt("#coNote","");refreshCart();const c=$("#closeCart");if(c)c.focus()};
const closeCart=()=>{if(!drawer)return;drawer.classList.remove("open");drawer.setAttribute("aria-hidden","true")};
if($("#openCart"))$("#openCart").addEventListener("click",openCart);
if($("#closeCart"))$("#closeCart").addEventListener("click",closeCart);if($("#scrim"))$("#scrim").addEventListener("click",closeCart);
document.addEventListener("keydown",e=>{if(e.key==="Escape")closeCart()});
if($("#checkout"))$("#checkout").addEventListener("click",()=>{if(DEMO){setTxt("#coNote","Preview mode. Checkout opens once your products are in Shopify.");return}location.href=ROOT+"checkout"});
renderCart();refreshCart();
addEventListener("pageshow",e=>{if(e.persisted)refreshCart()});

/* ---------- intake ---------- */
// Each answer points to one condition. The findings line quotes your answers back to you.
const Q=[
 {q:"How did you sleep?",k:"Slept",o:[["I didn’t","ins"],["Fine, until my brain started talking","anx"],["Eleven hours. Still tired.","bur"],["Phone in hand, as usual","ovr"]]},
 {q:"What’s draining you most?",k:"Drained by",o:[["My inbox","bur"],["The news","ovr"],["Other people","agi"],["Worst-case scenarios","anx"],["The ceiling, at 3am","ins"]]},
 {q:"Pick a symptom.",k:"Symptom",o:[["Racing thoughts","anx"],["Tired eyes","ovr"],["Short fuse","agi"],["The 3pm crash","bur"],["Wide awake at night","ins"]]},
 {q:"How do you cope?",k:"Copes by",o:[["Scrolling","ovr"],["Sighing loudly","agi"],["Coffee","bur"],["Lying very still","ins"],["Making a joke about it","anx"]]},
 {q:"How are you, honestly?",k:"Self-report",o:[["Fine, thanks.",null]]}
];
const DX={
 ins:{dx:"Sleep debt, compounding",sig:"Wear at bedtime. Lie still. Think about everything.",pool:["surmontil","dalmane-eye","quaalude-morning","noritren"]},
 anx:{dx:"Chronic overthinking",sig:"Wear daily. Overthink the fit. That’s normal.",pool:["serenol","xanax-splatter","valium-tension","oblivon","xanax-structure"]},
 bur:{dx:"Low battery syndrome",sig:"Wear once daily. Do not operate small talk.",pool:["ritalin","plug","valium","mornidine"]},
 ovr:{dx:"Sensory overload",sig:"Wear when you’ve seen enough. Close tabs as needed.",pool:["visine","thorazine-eye","blue-hand","osporot"]},
 agi:{dx:"Mild hostility toward everyone",sig:"Wear in public. Count to ten. Then eleven.",pool:["haldol-belligerent","thorazine-cane","thorazine-face","stelazine-pair"]}
};
const form=$("#intakeForm");
const findProd=id=>byId[id]||PRODUCTS.find(p=>p.id.startsWith(id))||PRODUCTS.find(p=>p.name.toLowerCase()===id.split("-")[0]);
if(form){
form.innerHTML=Q.map((x,i)=>`<fieldset><legend><span class="q">Q${i+1}</span>${x.q}</legend><div class="opts">${x.o.map((o,j)=>`<label><input type="radio" name="q${i}" id="q${i}_${j}" value="${j}"><span>${o[0]}</span></label>`).join("")}</div></fieldset>`).join("")+
 `<div class="foot"><span class="mono mute" id="prog">0 of ${Q.length} answered</span><button class="btn" id="diagnose" type="submit" disabled>Get diagnosis</button></div>`;
const answered=()=>Q.map((x,i)=>form.querySelector(`input[name=q${i}]:checked`)).filter(Boolean).length;
form.addEventListener("change",()=>{const n=answered();$("#prog").textContent=n===Q.length?"All answered. Brave.":`${n} of ${Q.length} answered`;$("#diagnose").disabled=n<Q.length});
let rxPick=null;
form.addEventListener("submit",e=>{
  e.preventDefault();
  const picks=Q.map((x,i)=>x.o[+form.querySelector(`input[name=q${i}]:checked`).value]);
  const tally={};picks.forEach(([,k],i)=>{if(k)tally[k]=(tally[k]||0)+(i===2?1.5:1)});   // the symptom question counts a little more
  const key=Object.entries(tally).sort((a,b)=>b[1]-a[1])[0][0];
  const d=DX[key];let pool=d.pool.map(findProd).filter(Boolean);if(!pool.length)pool=PRODUCTS;
  const p=pool[Math.floor(Math.random()*pool.length)];rxPick=p.id;
  $("#sFind").textContent=Q.slice(0,4).map((x,i)=>`${x.k}: ${picks[i][0].toLowerCase().replace(/\bi\b/g,"I")}`).join(". ")+". Reports feeling fine.";
  $("#sDx").textContent=d.dx;$("#sSig").textContent=d.sig;$("#sRef").textContent="Unlimited. Side effects may include honesty.";
  $("#sTee").hidden=false;$("#sImg").src=THUMB(p.views[0]);$("#sName").textContent=p.name;$("#sCode").textContent=`${p.code} · ${money(p.price)}`;
  $("#fill").hidden=false;
  const s=$("#slip");s.classList.remove("pending","filled");void s.offsetWidth;s.classList.add("filled");
  if(matchMedia("(max-width:900px)").matches)s.scrollIntoView({behavior:"smooth",block:"start"});
});
$("#fill").addEventListener("click",()=>{if(rxPick)openProduct(rxPick)});
}

/* ---------- dose ---------- */
let doses=0,doseT,offT;
const ONSET=["Onset: immediate.","Feeling something. Briefly.","Colors detected.","Effects may vary.","This is the good part."];
/* headline distortion: ramps the SVG displacement up and back down */
const tripMap=document.getElementById("tripMap");let tripLvl=0,tripTgt=0,tripRAF=0;
function tripTick(){tripLvl+=(tripTgt-tripLvl)*0.06;
  const wob=tripTgt?Math.sin(performance.now()/420)*6:0;
  tripMap&&tripMap.setAttribute("scale",(tripLvl*(26+wob)).toFixed(2));
  if(Math.abs(tripTgt-tripLvl)>.005||tripTgt){tripRAF=requestAnimationFrame(tripTick)}else{tripRAF=0;tripMap&&tripMap.setAttribute("scale","0")}}
function trip(on){if(matchMedia("(prefers-reduced-motion: reduce)").matches)return;tripTgt=on?1:0;if(!tripRAF)tripRAF=requestAnimationFrame(tripTick)}
function dose(){
  doses++;setTxt("#doses",doses);
  document.body.classList.add("dosed");trip(true);toast(ONSET[(doses-1)%ONSET.length],2000);
  clearTimeout(doseT);clearTimeout(offT);
  doseT=setTimeout(()=>{toast("Effects wearing off. Back to normal.",2400);trip(false);offT=setTimeout(()=>document.body.classList.remove("dosed"),1400)},6000);
}

const SPILL=["Contents may settle.","Oops. Dosage: everywhere.","Spilled. Still fine.","Results scattered. Inconclusive."];
let spills=0;
function spilled(){doses++;setTxt("#doses",doses);toast(SPILL[spills++%SPILL.length],2200)}
/* ---------- decorative pills parallax ---------- */
const decos=$$(".deco").map(el=>({el,sp:+el.dataset.speed||.1,rot:+((el.style.transform.match(/-?\d+(\.\d+)?/)||[0])[0])}));
let raf=0;
addEventListener("scroll",()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;decos.forEach(d=>{const r=d.el.parentElement.getBoundingClientRect();const y=(r.top+r.height/2-innerHeight/2)*d.sp;d.el.style.transform=`translateY(${y}px) rotate(${d.rot+y*.25}deg)`})})},{passive:true});

/* ---------- pill canvas ---------- */
const cv=$("#pills");let ctx=cv?cv.getContext("2d"):null;
const reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
const PAIRS=[["pink","white"],["orange","yellow"],["blue","white"],["mint","blue"],["violet","pink"],["yellow","white"],["pink","orange"],["blue","yellow"]];
const TABS=["yellow","mint","pink","blue","white","orange"];
let W=0,H=0,DPR=1,pills=[],running=false,visible=true,mouse={x:-9999,y:-9999},drag=null,last=performance.now();
function size(){const r=cv.getBoundingClientRect();DPR=Math.min(2,devicePixelRatio||1);W=r.width;H=r.height;cv.width=Math.round(W*DPR);cv.height=Math.round(H*DPR)}
const rnd=(a,b)=>a+Math.random()*(b-a);
function makePill(edge,forceClear){
  const base=Math.max(56,Math.min(120,W*.07));const z=rnd(.65,1.25);const tab=Math.random()<.3;
  const pr=PAIRS[Math.floor(Math.random()*PAIRS.length)];
  const p={z,tab,len:base*z*(tab?1:1.2),r:base*z*(tab?.42:.22),c1:COLORS[tab?TABS[Math.floor(Math.random()*TABS.length)]:pr[0]],c2:COLORS[pr[1]],
    a:rnd(0,Math.PI*2),va:rnd(-.6,.6),vx:rnd(-18,18),vy:rnd(-14,14),s:edge?0:1,taken:0};
  if(!tab&&(forceClear||(pr[0]==="blue"&&pr[1]==="white"))){p.clear=true;p.c1=COLORS.blue;p.z=Math.max(p.z,1.05);p.len=base*p.z*1.3;p.r=base*p.z*.24;p.beads=makeBeads(p)}
  p.x=rnd(p.len,W-p.len);p.y=rnd(p.len,H-p.len);
  return p;
}
const BEADC=["#ff3d8e","#ffd60a","#22d39c","#ff6a1a","#8b4dff","#fbfbf7","#2d55ff"];
function makeBeads(p,forcePair){
  // tightly packed, overlapping beads that fill the clear half completely
  const L=p.len,r=p.r,br=r*.155,out=[];
  const BP=[["#ff3d8e","#fbfbf7"],["#ffd60a","#ff6a1a"],["#22d39c","#fbfbf7"],["#8b4dff","#ff3d8e"],["#ff6a1a","#fbfbf7"],["#ffd60a","#22d39c"],["#ff3d8e","#ffd60a"],["#8b4dff","#fbfbf7"]];
  const pair=forcePair||BP[Math.floor(Math.random()*BP.length)];
  const sx=br*1.38, sy=sx*.866, cx=L/2-r;
  for(let layer=0;layer<2;layer++){
    const ox=layer?sx/2:0, oy=layer?sy/2:0;
    for(let row=0,y=-r-br+oy;y<=r+br;row++,y+=sy){
      for(let x=(row%2?sx/2:0)+ox-br*.4;x<=L/2+br;x+=sx){
        if(x>cx&&Math.hypot(x-cx,y)>r+br*.6)continue;
        out.push({x:x+rnd(-.22,.22)*br,y:y+rnd(-.22,.22)*br,r:br*rnd(.92,1.1),c:pair[Math.random()<.5?0:1],back:!layer});
      }
    }
  }
  out.sort((m,n)=>(n.back?1:0)-(m.back?1:0));
  return out;
}
function seed(){pills=[];const n=W<600?9:W<1000?13:17;for(let i=0;i<n;i++)pills.push(makePill(false,i<(W<600?2:3)));myPills().forEach(s=>pills.push(makeMine(s,false)));pills.sort((a,b)=>a.z-b.z)}
/* ---------- your own pills ---------- */
const SWC={...COLORS,ink:"#2a2a27"};
const myPills=()=>{try{return JSON.parse(localStorage.getItem("ft-mypills")||"[]")}catch(e){return[]}};
const saveMy=l=>{try{localStorage.setItem("ft-mypills",JSON.stringify(l))}catch(e){}};
function specPill(sp,base,z){
  const p={z,tab:sp.shape==="tab",a:0,va:0,vx:0,vy:0,s:1,taken:0,spec:sp,imp:(sp.imp||"").toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,4)};
  p.len=base*z*(p.tab?1:1.2);p.r=base*z*(p.tab?.42:.22);p.c1=SWC[sp.c1];p.c2=SWC[sp.c2];
  if(sp.shape==="bead"){p.clear=true;p.len=base*z*1.3;p.r=base*z*.24;p.beads=makeBeads(p,[SWC[sp.c2],sp.c2==="white"?"#ffd60a":"#fbfbf7"])}
  return p;
}
function makeMine(sp,edge){const base=Math.max(56,Math.min(120,W*.07));const p=specPill(sp,base,1.15);p.mine=true;p.s=edge?0:1;p.a=rnd(0,Math.PI*2);p.va=rnd(-.5,.5);p.vx=rnd(-18,18);p.vy=rnd(-14,14);p.x=rnd(p.len,W-p.len);p.y=rnd(p.len,H-p.len);return p}
function drawPill(p){
  const sc=p.s*(1+p.taken*.8);if(sc<=0)return;
  ctx.save();ctx.globalAlpha=1-p.taken;
  const px=p.x+(mouse.x>-999?(mouse.x-W/2)*.02*(p.z-1):0),py=p.y+(mouse.y>-999?(mouse.y-H/2)*.02*(p.z-1):0);
  ctx.translate(px,py);
  if(p.mine&&p.glow>0){const R=(p.tab?p.r:p.len/2)*sc*1.38;ctx.save();ctx.globalAlpha=Math.min(1,p.glow)*(1-p.taken);ctx.strokeStyle="#ff3d8e";ctx.lineWidth=2;ctx.setLineDash([6,7]);ctx.lineDashOffset=-performance.now()/40;ctx.beginPath();ctx.arc(0,0,R,0,Math.PI*2);ctx.stroke();ctx.setLineDash([]);ctx.font='500 11px "IBM Plex Mono",monospace';ctx.textAlign="center";ctx.fillStyle="#ff3d8e";ctx.fillText("YOURS",0,-R-8);ctx.restore()}
  ctx.rotate(p.a);ctx.scale(sc,sc);
  if(p.tab){
    const R=p.r;ctx.shadowColor="rgba(0,0,0,.28)";ctx.shadowBlur=18*p.z;ctx.shadowOffsetY=10*p.z;
    ctx.beginPath();ctx.ellipse(0,0,R,R,0,0,Math.PI*2);ctx.fillStyle=p.c1;ctx.fill();ctx.shadowColor="transparent";
    const g=ctx.createRadialGradient(-R*.35,-R*.4,R*.1,0,0,R);g.addColorStop(0,"rgba(255,255,255,.65)");g.addColorStop(.5,"rgba(255,255,255,.05)");g.addColorStop(1,"rgba(0,0,0,.22)");
    ctx.fillStyle=g;ctx.fill();
    if(!p.imp){ctx.strokeStyle="rgba(0,0,0,.18)";ctx.lineWidth=Math.max(1.5,R*.06);ctx.beginPath();ctx.moveTo(-R*.72,0);ctx.lineTo(R*.72,0);ctx.stroke();
    ctx.strokeStyle="rgba(255,255,255,.35)";ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(-R*.72,1.5);ctx.lineTo(R*.72,1.5);ctx.stroke();}
  }else if(p.clear){
    drawClear(p);
  }else{
    const L=p.len,r=p.r;
    const path=()=>{ctx.beginPath();ctx.moveTo(-L/2+r,-r);ctx.lineTo(L/2-r,-r);ctx.arc(L/2-r,0,r,-Math.PI/2,Math.PI/2);ctx.lineTo(-L/2+r,r);ctx.arc(-L/2+r,0,r,Math.PI/2,Math.PI*1.5);ctx.closePath()};
    path();ctx.shadowColor="rgba(0,0,0,.28)";ctx.shadowBlur=20*p.z;ctx.shadowOffsetY=12*p.z;ctx.fillStyle=p.c2;ctx.fill();ctx.shadowColor="transparent";
    ctx.save();path();ctx.clip();
    ctx.fillStyle=p.c2;ctx.fillRect(0,-r,L/2,2*r);ctx.fillStyle=p.c1;ctx.fillRect(-L/2,-r,L/2+1,2*r);
    ctx.fillStyle="rgba(0,0,0,.12)";ctx.fillRect(-1,-r,2,2*r);
    const g=ctx.createLinearGradient(0,-r,0,r);g.addColorStop(0,"rgba(255,255,255,.6)");g.addColorStop(.35,"rgba(255,255,255,.08)");g.addColorStop(.7,"rgba(0,0,0,0)");g.addColorStop(1,"rgba(0,0,0,.26)");
    ctx.fillStyle=g;ctx.fillRect(-L/2,-r,L,2*r);
    ctx.fillStyle="rgba(255,255,255,.75)";ctx.beginPath();ctx.ellipse(-L*.18,-r*.52,L*.2,r*.14,0,0,Math.PI*2);ctx.fill();
    ctx.restore();
  }
  if(p.imp&&!p.clear){const fs=p.tab?p.r*.52:p.r*.9,tx=p.tab?0:p.len*.23;ctx.font=`700 ${fs}px "IBM Plex Mono",monospace`;ctx.textAlign="center";ctx.textBaseline="middle";
    ctx.fillStyle="rgba(255,255,255,.4)";ctx.fillText(p.imp,tx,1.2);ctx.fillStyle="rgba(0,0,0,.4)";ctx.fillText(p.imp,tx,0)}
  ctx.restore();
}
function bead(x,y,R,c,dim){
  ctx.beginPath();ctx.arc(x,y,R,0,Math.PI*2);ctx.fillStyle=c;ctx.fill();
  ctx.strokeStyle=dim?"rgba(0,0,0,.28)":"rgba(0,0,0,.16)";ctx.lineWidth=Math.max(.6,R*.18);ctx.stroke();
  if(dim){ctx.fillStyle="rgba(0,0,0,.18)";ctx.fill()}
  ctx.beginPath();ctx.arc(x-R*.32,y-R*.36,R*.32,0,Math.PI*2);ctx.fillStyle="rgba(255,255,255,.75)";ctx.fill();
}
function drawClear(p){
  const L=p.len,r=p.r,o=p.open||0;
  const sep=o?Math.min(1,o*2.2)*L*.32:0, tilt=o?Math.min(1,o*2.2)*.35:0;
  const half=(side)=>{ // side -1 = blue cap (left), +1 = clear body (right)
    ctx.beginPath();
    if(side<0){ctx.moveTo(0,-r);ctx.lineTo(-L/2+r,-r);ctx.arc(-L/2+r,0,r,Math.PI*1.5,Math.PI/2,true);ctx.lineTo(0,r)}
    else{ctx.moveTo(0,-r);ctx.lineTo(L/2-r,-r);ctx.arc(L/2-r,0,r,-Math.PI/2,Math.PI/2);ctx.lineTo(0,r)}
    if(!o)ctx.closePath();
  };
  // shadow
  ctx.save();ctx.shadowColor="rgba(0,0,0,.22)";ctx.shadowBlur=18*p.z;ctx.shadowOffsetY=12*p.z;
  ctx.save();ctx.translate(-sep,0);ctx.rotate(-tilt);half(-1);ctx.closePath();ctx.fillStyle=p.c1;ctx.fill();ctx.restore();
  ctx.save();ctx.translate(sep,0);ctx.rotate(tilt);half(1);ctx.closePath();ctx.fillStyle="rgba(255,255,255,.16)";ctx.fill();ctx.restore();
  ctx.restore();
  // blue cap shading
  ctx.save();ctx.translate(-sep,0);ctx.rotate(-tilt);half(-1);ctx.closePath();ctx.clip();
  let g=ctx.createLinearGradient(0,-r,0,r);g.addColorStop(0,"rgba(255,255,255,.55)");g.addColorStop(.35,"rgba(255,255,255,.06)");g.addColorStop(1,"rgba(0,0,0,.28)");
  ctx.fillStyle=g;ctx.fillRect(-L/2,-r,L/2,2*r);
  ctx.fillStyle="rgba(255,255,255,.7)";ctx.beginPath();ctx.ellipse(-L*.24,-r*.52,L*.13,r*.13,0,0,Math.PI*2);ctx.fill();
  ctx.restore();
  // clear body: beads inside, then glass
  ctx.save();ctx.translate(sep,0);ctx.rotate(tilt);
  half(1);ctx.closePath();ctx.save();ctx.clip();
  if(!o)p.beads.forEach(b=>bead(b.x,b.y,b.r,b.c,b.back));
  g=ctx.createLinearGradient(0,-r,0,r);g.addColorStop(0,"rgba(255,255,255,.55)");g.addColorStop(.22,"rgba(255,255,255,.12)");g.addColorStop(.75,"rgba(255,255,255,0)");g.addColorStop(1,"rgba(120,140,170,.18)");
  ctx.fillStyle=g;ctx.fillRect(0,-r,L/2,2*r);
  ctx.fillStyle="rgba(255,255,255,.8)";ctx.beginPath();ctx.ellipse(L*.2,-r*.6,L*.14,r*.1,0,0,Math.PI*2);ctx.fill();
  ctx.restore();
  half(1);ctx.strokeStyle="rgba(40,60,90,.4)";ctx.lineWidth=Math.max(1.4,r*.06);ctx.stroke();
  half(1);ctx.strokeStyle="rgba(255,255,255,.6)";ctx.lineWidth=1;ctx.stroke();
  ctx.restore();
  // seam ring where halves meet
  if(!o){ctx.fillStyle="rgba(0,0,0,.14)";ctx.fillRect(-1.5,-r,3,2*r)}
}
/* spilled beads */
let spill=[];
function openPill(p){
  p.open=.001;p.vx*=.2;p.vy*=.2;
  const c=Math.cos(p.a),s=Math.sin(p.a);
  p.beads.filter(b=>!b.back).forEach((b,i)=>{
    const wx=p.x+b.x*c-b.y*s, wy=p.y+b.x*s+b.y*c;
    const sp=rnd(140,420);
    spill.push({depth:rnd(0,b.r*1.4),x:wx,y:wy,r:b.r,c:b.c,vx:c*sp*.6+rnd(-70,70),vy:s*sp*.4+rnd(-160,-20),age:0,life:rnd(5,7),delay:i*.006});
  });
  if(spill.length>360)spill.splice(0,spill.length-360);
}
function stepSpill(dt){
  // no bead-on-bead collisions: each bead lands, rolls outward and stops, so the spill spreads into a loose scatter
  const floor=H-6;
  spill.forEach(b=>{
    if(b.delay>0){b.delay-=dt;return}
    b.age+=dt;if(b.sleep)return;
    const rest=floor-b.r-b.depth;
    if(!b.landed){
      b.vy+=1500*dt;b.x+=b.vx*dt;b.y+=b.vy*dt;
      if(b.y>=rest){b.y=rest;b.landed=true;b.vy=0;
        b.vx=b.vx*.35+(Math.random()<.5?-1:1)*rnd(60,260)}   // splash sideways on impact
    }else{
      b.x+=b.vx*dt;b.vx*=Math.pow(.12,dt);                    // smooth rolling friction
      if(Math.abs(b.vx)<4){b.vx=0;b.sleep=true}
    }
    if(b.x<b.r){b.x=b.r;b.vx=Math.abs(b.vx)*.25}if(b.x>W-b.r){b.x=W-b.r;b.vx=-Math.abs(b.vx)*.25}
  });
  spill=spill.filter(b=>b.age<b.life);
}
function drawSpill(){spill.slice().sort((m,n)=>m.y-n.y).forEach(b=>{if(b.delay>0)return;ctx.save();ctx.globalAlpha=Math.min(1,(b.life-b.age)/1.2);bead(b.x,b.y,b.r,b.c);ctx.restore()})}
function hit(x,y){
  for(let i=pills.length-1;i>=0;i--){const p=pills[i];if(p.taken||p.open||p.s<.9)continue;const dx=x-p.x,dy=y-p.y,c=Math.cos(-p.a),s=Math.sin(-p.a);const lx=dx*c-dy*s,ly=dx*s+dy*c;
    if(p.tab?Math.hypot(lx,ly)<=p.r*1.05:(Math.abs(lx)<=p.len/2&&Math.abs(ly)<=p.r*1.15))return p}
  return null;
}
function step(dt){
  pills.forEach(p=>{
    if(p.taken){p.taken+=dt*2.6;return}
    if(p.open){p.open+=dt;p.x+=p.vx*dt;p.y+=p.vy*dt;if(p.open>1.1)p.taken=.001;return}
    if(p.s<1)p.s=Math.min(1,p.s+dt*2.2);
    if(drag&&drag.p===p)return;
    // mouse nudge
    const dx=p.x-mouse.x,dy=p.y-mouse.y,d=Math.hypot(dx,dy),R=140;
    if(d<R&&d>0&&!drag){const f=(1-d/R)*260*dt;p.vx+=dx/d*f;p.vy+=dy/d*f}
    p.x+=p.vx*dt;p.y+=p.vy*dt;p.a+=p.va*dt;
    const sp=Math.hypot(p.vx,p.vy);if(sp>22){p.vx*=1-dt*.9;p.vy*=1-dt*.9}
    p.va*=Math.abs(p.va)>.7?1-dt*.8:1;
    const m=p.len*.4;
    if(p.x<m){p.x=m;p.vx=Math.abs(p.vx)*.8}if(p.x>W-m){p.x=W-m;p.vx=-Math.abs(p.vx)*.8}
    if(p.y<m){p.y=m;p.vy=Math.abs(p.vy)*.8}if(p.y>H-m){p.y=H-m;p.vy=-Math.abs(p.vy)*.8}
  });
  for(let i=pills.length-1;i>=0;i--)if(pills[i].taken>=1){const gone=pills.splice(i,1)[0];if(gone.removed)continue;setTimeout(()=>{if(!W)return;const n=gone.mine?makeMine(gone.spec,true):makePill(true);if(gone.mine&&!myPills().some(s=>s.id===gone.spec.id))return;pills.push(n);pills.sort((a,b)=>a.z-b.z)},2400)}
  pills.forEach(p=>{if(p.glow>0)p.glow-=dt*.11});
}
function frame(t){
  if(!running)return;
  const dt=Math.min(.05,(t-last)/1000);last=t;
  if(!reduce){step(dt);stepSpill(dt)}else pills.forEach(p=>{if(p.taken)p.taken+=dt*2.6;p.s=1});
  ctx.setTransform(DPR,0,0,DPR,0,0);ctx.clearRect(0,0,W,H);pills.forEach(drawPill);drawSpill();
  if(reduce)for(let i=pills.length-1;i>=0;i--)if(pills[i].taken>=1)pills.splice(i,1);
  requestAnimationFrame(frame);
}
function pillsActive(on){const go=on&&visible;if(go&&!running){running=true;last=performance.now();requestAnimationFrame(frame)}else if(!go)running=false}
if(cv){
const local=e=>{const r=cv.getBoundingClientRect();return{x:e.clientX-r.left,y:e.clientY-r.top}};
cv.addEventListener("pointermove",e=>{const m=local(e);mouse=m;
  if(drag){const t=performance.now(),p=drag.p;const ndt=Math.max(.008,(t-drag.t)/1000);p.vx=(m.x-drag.lx)/ndt;p.vy=(m.y-drag.ly)/ndt;p.x=m.x-drag.ox;p.y=m.y-drag.oy;drag.lx=m.x;drag.ly=m.y;drag.t=t;drag.moved+=Math.abs(e.movementX||0)+Math.abs(e.movementY||0);return}
  cv.style.cursor=hit(m.x,m.y)?"pointer":"grab"});
cv.addEventListener("pointerleave",()=>{mouse={x:-9999,y:-9999}});
cv.addEventListener("pointerdown",e=>{const m=local(e);const p=hit(m.x,m.y);if(!p)return;
  drag={p,ox:m.x-p.x,oy:m.y-p.y,lx:m.x,ly:m.y,t:performance.now(),t0:performance.now(),moved:0};cv.classList.add("drag");cv.setPointerCapture(e.pointerId);
  pills.splice(pills.indexOf(p),1);pills.push(p)});
const release=()=>{if(!drag)return;const p=drag.p;cv.classList.remove("drag");
  if(drag.moved<8&&performance.now()-drag.t0<400){
    if(p.clear&&!reduce){openPill(p);spilled()}else{p.taken=.001;p.vx=p.vy=0;dose()}}
  else{const sp=Math.hypot(p.vx,p.vy),max=1400;if(sp>max){p.vx*=max/sp;p.vy*=max/sp}p.va=(p.vx/300)*(Math.random()<.5?-1:1)}
  drag=null};
cv.addEventListener("pointerup",release);cv.addEventListener("pointercancel",release);
cv.addEventListener("keydown",e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();const p=pills.find(p=>!p.taken);if(p){p.taken=.001;dose()}}});
cv.tabIndex=0;
new ResizeObserver(()=>{const ow=W;size();if(W<50)return;if(ow<50||!pills.length||Math.abs(ow-W)>200)seed();else pills.forEach(p=>{p.x=Math.min(p.x,W-20);p.y=Math.min(p.y,H-20)})}).observe(cv);
new IntersectionObserver(es=>{visible=es[0].isIntersecting;pillsActive(true)}).observe(cv);
size();if(W>50)seed();
}


/* ---------- investors (content is AES-encrypted; the password decrypts it in the browser) ---------- */
/*INVESTOR*/
(function(){
  const gate=$("#ivGate"),body=$("#ivBody"),pw=$("#ivPw"),err=$("#ivErr");
  if(!gate||!window.INVESTOR)return;const INVESTOR=window.INVESTOR;
  const unb=s=>Uint8Array.from(atob(s),c=>c.charCodeAt(0));
  async function unlock(p){
    const base=await crypto.subtle.importKey("raw",new TextEncoder().encode(p),"PBKDF2",false,["deriveKey"]);
    const key=await crypto.subtle.deriveKey({name:"PBKDF2",salt:unb(INVESTOR.s),iterations:INVESTOR.n,hash:"SHA-256"},base,{name:"AES-GCM",length:256},false,["decrypt"]);
    const out=await crypto.subtle.decrypt({name:"AES-GCM",iv:unb(INVESTOR.i)},key,unb(INVESTOR.c));
    body.innerHTML=new TextDecoder().decode(out).replace(/img\/p\/([\w-]+\.webp)/g,(m,n)=>A("p_"+n));gate.hidden=true;body.hidden=false;initDeck();
    try{sessionStorage.setItem("ft-iv",p)}catch(e){}
  }

  function initDeck(){
    const stage=$("#dkStage");if(!stage)return;
    const slides=[...stage.querySelectorAll(".dk-slide")];let i=0;
    const fit=()=>{const w=stage.clientWidth||stage.getBoundingClientRect().width;if(!w)return;const h=stage.clientHeight||w*9/16;
      const k=Math.min(w/1920,h/1080),sw=1920*k,sh=1080*k;
      slides.forEach(s=>{s.style.cssText=`position:absolute;left:${(w-sw)/2}px;top:${(h-sh)/2}px;width:${sw}px;height:${sh}px;right:auto;bottom:auto`;s.firstElementChild.style.setProperty("--k",k)})};
    if(window.ResizeObserver)new ResizeObserver(fit).observe(stage);const show=n=>{i=(n+slides.length)%slides.length;slides.forEach((s,k)=>s.hidden=k!==i);$("#dkCount").textContent=`${i+1} / ${slides.length}`;fit()};
    $("#dkPrev").onclick=()=>show(i-1);$("#dkNext").onclick=()=>show(i+1);
    const x=document.createElement("button");x.className="dk-x";x.type="button";x.setAttribute("aria-label","Exit full screen");x.textContent="\u2715";stage.appendChild(x);
    const pseudo=on=>{stage.classList.toggle("pseudo",on);document.documentElement.classList.toggle("dk-lock",on);$("#dkFull").textContent=on?"Exit":"Full screen";setTimeout(fit,30)};
    x.onclick=e=>{e.stopPropagation();pseudo(false)};
    addEventListener("keydown",e=>{if(e.key==="Escape"&&stage.classList.contains("pseudo"))pseudo(false)});
    $("#dkFull").onclick=()=>{if(stage.classList.contains("pseudo"))return pseudo(false);
      const touch=matchMedia("(hover:none)").matches||!stage.requestFullscreen;
      if(touch)return pseudo(true);
      document.fullscreenElement?document.exitFullscreen():stage.requestFullscreen()};
    let sx=null,sy=0,swiped=false;
    stage.addEventListener("touchstart",e=>{sx=e.touches[0].clientX;sy=e.touches[0].clientY;swiped=false},{passive:true});
    stage.addEventListener("touchend",e=>{if(sx==null)return;const t=e.changedTouches[0];let dx=t.clientX-sx,dy=t.clientY-sy;
      if(stage.classList.contains("pseudo")&&matchMedia("(orientation:portrait)").matches){const q=dx;dx=dy;dy=-q}
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){swiped=true;show(dx<0?i+1:i-1)}sx=null},{passive:true});
    stage.addEventListener("click",e=>{if(swiped){swiped=false;return}if(e.target.closest(".dk-x"))return;
      const r=stage.getBoundingClientRect();const rot=stage.classList.contains("pseudo")&&matchMedia("(orientation:portrait)").matches;
      const f=rot?(e.clientY-r.top)/r.height:(e.clientX-r.left)/r.width;show(f<1/3?i-1:i+1)});
    addEventListener("keydown",e=>{if(body.hidden)return;if(e.key==="ArrowRight")show(i+1);if(e.key==="ArrowLeft")show(i-1)});
    addEventListener("resize",fit);document.addEventListener("fullscreenchange",()=>setTimeout(fit,50));
    const nav=$("#dkPrev").parentElement;if(nav&&!nav.nextElementSibling?.classList?.contains("dk-swipe")){const p=document.createElement("p");p.className="dk-swipe mono";p.textContent="Swipe to flip \u00b7 Full screen turns it sideways";nav.after(p)}
    show(0);
  }
  gate.addEventListener("submit",async e=>{e.preventDefault();err.hidden=true;
    try{await unlock(pw.value)}catch(x){err.hidden=false;pw.select()}});
  let saved=null;try{saved=sessionStorage.getItem("ft-iv")}catch(e){}
  if(saved)unlock(saved).catch(()=>{});
})();

/* ---------- press your own pill (UI) ---------- */
(function(){
  const stage=$("#pStage"),pc=$("#pressCv");if(!stage||!pc)return;const px=pc.getContext("2d");
  const ORDER=["pink","orange","yellow","mint","blue","violet","white","ink"];
  const NAMES={pink:"Pink",orange:"Orange",yellow:"Yellow",mint:"Mint",blue:"Blue",violet:"Violet",white:"White",ink:"Black"};
  const LBL={cap:["Left half","Right half"],tab:["Color",""],bead:["Cap","Beads"]};
  let spec={shape:"cap",c1:"pink",c2:"white",imp:""},prev=null,state="idle",t0=0,launchT=0,vis=false,loop=false;
  const sw=(el,key)=>{el.innerHTML=ORDER.map(c=>`<button type="button" data-c="${c}" style="background:${SWC[c]}" aria-label="${NAMES[c]}" aria-pressed="${spec[key]===c}"></button>`).join("");
    el.querySelectorAll("button").forEach(b=>b.onclick=()=>{spec[key]=b.dataset.c;el.querySelectorAll("button").forEach(x=>x.setAttribute("aria-pressed",String(x===b)));rebuild()})};
  function labels(){const[l1,l2]=LBL[spec.shape];$("#pL1").textContent=l1;$("#pL2").textContent=l2;$("#pR2").hidden=!l2;$("#pR3").hidden=spec.shape==="bead"}
  function sizeP(){const r=pc.getBoundingClientRect(),d=Math.min(2,devicePixelRatio||1);pc.width=Math.round(r.width*d);pc.height=Math.round(r.height*d)}
  function rebuild(){const r=pc.getBoundingClientRect();if(!r.width)return;prev=specPill(spec,r.width*.26,1);prev.x=r.width/2;prev.y=r.height*.6;labels()}
  $$("#pShape button").forEach(b=>b.onclick=()=>{spec.shape=b.dataset.v;$$("#pShape button").forEach(x=>x.setAttribute("aria-pressed",String(x===b)));rebuild()});
  sw($("#pC1"),"c1");sw($("#pC2"),"c2");
  $("#pImp").addEventListener("input",e=>{e.target.value=e.target.value.toUpperCase().replace(/[^A-Z0-9]/g,"");spec.imp=e.target.value;rebuild()});
  function draw(t){
    if(!vis){loop=false;return}
    const r=pc.getBoundingClientRect(),d=pc.width/Math.max(1,r.width);
    px.setTransform(d,0,0,d,0,0);px.clearRect(0,0,r.width,r.height);
    if(prev){
      let sq=0,dy=0,al=1;const e=(t-t0)/1000;
      if(state==="press"){sq=Math.min(1,e/.14);if(e>.32){state="launch";launchT=t}}
      if(state==="launch"){const f=(t-launchT)/1000;sq=Math.max(0,1-f*6);dy=-Math.pow(f,1.7)*r.height*3.2;al=Math.max(0,1-f*1.6);if(f>.7){state="gone"}}
      if(state==="gone"){al=0}
      if(state==="idle"){prev.a=Math.sin(t/1400)*.22-.18;dy=Math.sin(t/900)*6}
      if(al>0){
        const sv=ctx,sm=mouse;ctx=px;mouse={x:-9999,y:-9999};
        px.save();px.globalAlpha=al;px.translate(prev.x,prev.y+dy);px.scale(1+sq*.14,1-sq*.22);px.translate(-prev.x,-prev.y-dy);
        const oy=prev.y;prev.y=oy+dy;drawPill(prev);prev.y=oy;px.restore();ctx=sv;mouse=sm;
        // floor shadow
        px.save();px.globalAlpha=.18*al*(1+dy/400);px.fillStyle="#000";px.beginPath();px.ellipse(prev.x,r.height*.86,prev.len*.42,prev.r*.32,0,0,Math.PI*2);px.fill();px.restore();
      }
    }
    requestAnimationFrame(draw);
  }
  function start(){if(!loop&&vis){loop=true;requestAnimationFrame(draw)}}
  new IntersectionObserver(es=>{vis=es[0].isIntersecting;start()}).observe(stage);
  new ResizeObserver(()=>{sizeP();rebuild()}).observe(pc);
  function refreshClear(){$("#pClear").hidden=!myPills().length}
  $("#pGo").onclick=()=>{
    if(state==="press"||state==="launch")return;
    const mine={...spec,id:Date.now().toString(36)};
    let l=myPills();l.push(mine);let drop=null;if(l.length>3){drop=l.shift()}saveMy(l);refreshClear();
    const fly=()=>{
      if(drop){const old=pills.find(p=>p.mine&&p.spec.id===drop.id);if(old){old.removed=true;old.taken=.001}}
      if(W>50){const p=makeMine(mine,false);p.x=W*rnd(.3,.7);p.y=H+p.len;p.vy=-rnd(480,600);p.vx=rnd(-80,80);p.va=rnd(-2.2,2.2);p.glow=1.4;pills.push(p);pills.sort((a,b)=>a.z-b.z)}
    };
    $("#pNote").textContent="Pressed. It’s up top with the others.";
    if(reduce){fly();window.scrollTo({top:0});return}
    state="press";t0=performance.now();stage.classList.add("down");
    setTimeout(()=>{stage.classList.remove("down");stage.classList.add("shake");setTimeout(()=>stage.classList.remove("shake"),300)},200);
    setTimeout(()=>{window.scrollTo({top:0,behavior:"smooth"})},700);
    setTimeout(fly,1300);
    setTimeout(()=>{state="idle";spec={...spec};rebuild()},2600);
  };
  $("#pClear").onclick=()=>{myPills().forEach(s=>{const p=pills.find(q=>q.mine&&q.spec.id===s.id);if(p){p.removed=true;p.taken=.001}});saveMy([]);refreshClear();$("#pNote").textContent="Removed. Back to the house blend."};
  refreshClear();labels();
})();

/* ---------- take a number ---------- */
(function(){
  const now=$("#tkNow"),chip=$("#tkChip");if(!now&&!chip)return;
  const INT=20, START=37, WAIT=5, GRACE=30; // a number is called every 20s
  const abs=()=>Math.floor(Date.now()/1000/INT);
  const fmt=a=>String((START+a)%100).padStart(2,"0");
  const get=()=>{try{return JSON.parse(localStorage.getItem("ft-ticket")||"null")}catch(e){return null}};
  const put=v=>{try{v?localStorage.setItem("ft-ticket",JSON.stringify(v)):localStorage.removeItem("ft-ticket")}catch(e){}};
  let mem=null;const tk=()=>get()||mem;
  const disp=$("#tkDisp"),ticket=$("#tkTicket");let lastA=-1,notified=false;
  const hint=t=>setTxt("#tkHint",t);
  const CODE=($("#tkCode")&&$("#tkCode").dataset.code)||"WAITED10";
  function render(){
    const a=abs(),t=tk();
    if(now&&a!==lastA){if(lastA>=0){now.classList.remove("ding");void now.offsetWidth;now.classList.add("ding")}now.textContent=fmt(a);lastA=a}
    if(!t){if(ticket)ticket.hidden=true;chip.hidden=true;if(disp)disp.classList.remove("taken");hint("Pull a ticket. Keep browsing. We’ll call you.");return}
    if(disp)disp.classList.add("taken");
    if(a>t.target+GRACE){put(null);mem=null;hint("You missed your number. Take another.");if(ticket)ticket.hidden=true;chip.hidden=true;return}
    const called=a>=t.target,ahead=t.target-a;
    if(ticket){ticket.hidden=false;setTxt("#tkNum",fmt(t.target));
      ticket.classList.toggle("called",called);$("#tkReward").hidden=!called;
      setTxt("#tkMsg",called?"Now serving. That’s you.":ahead===1?"You’re next.":`${ahead} ahead of you. Please wait to be called.`)}
    hint(called?"Your wait is over.":"Keep browsing. We’ll call you.");
    chip.hidden=false;chip.classList.toggle("called",called);
    chip.innerHTML=called?`No. ${fmt(t.target)} · <b>You’re up · 10% off</b>`:`No. ${fmt(t.target)} · Now serving <b>${fmt(a)}</b>`;
    if(called&&!notified&&!t.seen){notified=true;toast(`Now serving ${fmt(t.target)}. That’s you. 10% off is waiting.`,4200)}
  }
  if(disp)disp.addEventListener("click",()=>{
    if(tk()){ticket.scrollIntoView({behavior:"smooth",block:"center"});return}
    const t={target:abs()+WAIT,at:Date.now()};mem=t;put(t);notified=false;
    disp.classList.add("pull");setTimeout(()=>disp.classList.remove("pull"),180);
    ticket.hidden=true;void ticket.offsetWidth;render();
    toast(`You’re number ${fmt(t.target)}. Please have a seat.`,2600);
  });
  chip.addEventListener("click",()=>{const ind=$("#indications");if(ind)ind.scrollIntoView({behavior:"smooth",block:"center"});else location.href=ROOT+"#indications"});
  if($("#tkCode"))$("#tkCode").addEventListener("click",()=>{try{navigator.clipboard.writeText(CODE)}catch(e){}
    if(!DEMO)fetch(ROOT+"discount/"+encodeURIComponent(CODE),{credentials:"same-origin"}).catch(()=>{});
    toast(DEMO?"Code copied.":"Code copied. It’s applied at checkout.",2400)});
  render();setInterval(render,1000);
})();
/* ---------- product page ---------- */
if(!IS_DLG&&$("#pdTrack")&&FT.product){const id=FT.product.id;if(byId[id])openProduct(id)}
})();
